import React from 'react';
import T from 'prop-types';

const Cursor = ({ currentTime = 0, pixelsPerSecond }) => {
  return (
    <div
      data-testid="cursor-admarker"
      className="editor-timeline__audio-cursor"
      style={{
        left: `${currentTime * pixelsPerSecond}px`,
      }}
    />
  );
};

Cursor.propTypes = {
  currentTime: T.number.isRequired,
  pixelsPerSecond: T.number.isRequired,
};

export default Cursor;
